import Vue from 'vue';
export default Vue.extend({
    name: 'errorPage',
    methods: {
        goMainPage() {
            window.location.href = window.location.origin;
        }
    }
});
